// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%236b7280%27 stroke-width=%272%27%3E%3Cpath d=%27M6 9l6 6 6-6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* EPIC-10 — CreerCandidatureModal — Design System Centralis */

/* Overlay */
.creer-candidature-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  backdrop-filter: blur(4px);
}

/* Modal container */
.creer-candidature-modal {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  max-width: 680px;
  width: 95%;
  max-height: 90vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  animation: creerCandidatureSlideIn 0.25s ease-out;
}

@keyframes creerCandidatureSlideIn {
  from {
    opacity: 0;
    transform: translateY(-24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Header */
.creer-candidature-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 28px;
  border-bottom: 1px solid #e5e7eb;
}

.creer-candidature-header-left {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.creer-candidature-modal-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #595959;
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    sans-serif;
}

/* Stepper */
.creer-candidature-steps {
  display: flex;
  align-items: center;
  gap: 6px;
}

.creer-candidature-step {
  font-size: 12px;
  font-weight: 500;
  color: #9ca3af;
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    sans-serif;
  transition: color 0.15s;
}

.creer-candidature-step.active {
  color: #f97316;
  font-weight: 600;
}

.creer-candidature-step.done {
  color: #6b7280;
}

.creer-candidature-step-sep {
  font-size: 14px;
  color: #d1d5db;
  line-height: 1;
}

/* ── Étape 2 ─────────────────────────────────────────────────────── */

.creer-candidature-step2 {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Choix solo / groupement */
.creer-candidature-type-choices {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.creer-candidature-type-option {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  cursor: pointer;
  transition:
    border-color 0.15s,
    background 0.15s;
  -webkit-user-select: none;
          user-select: none;
}

.creer-candidature-type-option:hover {
  border-color: #f97316;
  background: #fff7ed;
}

.creer-candidature-type-option.selected {
  border-color: #f97316;
  background: #fff7ed;
}

.creer-candidature-type-option input[type="radio"] {
  margin-top: 2px;
  width: 16px;
  height: 16px;
  accent-color: #f97316;
  flex-shrink: 0;
  cursor: pointer;
}

.creer-candidature-type-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 2px;
}

.creer-candidature-type-desc {
  display: block;
  font-size: 12px;
  color: #6b7280;
  line-height: 1.5;
}

/* ── Membres / invitation ─────────────────────────────────────── */

.creer-candidature-membres {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.creer-candidature-search-wrapper {
  position: relative;
}

.creer-candidature-search-input {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 14px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  color: #374151;
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    sans-serif;
  transition: border-color 0.15s;
}

.creer-candidature-search-input:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
}

.creer-candidature-search-spinner {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  border: 2px solid #e5e7eb;
  border-top-color: #f97316;
  border-radius: 50%;
  animation: creerSpin 0.7s linear infinite;
  pointer-events: none;
}

.creer-candidature-search-results {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  z-index: 100;
  max-height: 200px;
  overflow-y: auto;
}

.creer-candidature-search-result-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 10px 14px;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    sans-serif;
  transition: background 0.12s;
}

.creer-candidature-search-result-item:hover {
  background: #fff7ed;
}

.creer-candidature-search-result-item:disabled,
.creer-candidature-search-result-item.disabled {
  cursor: not-allowed;
  opacity: 0.55;
  background: #f9fafb;
}

.creer-candidature-search-result-item:disabled:hover,
.creer-candidature-search-result-item.disabled:hover {
  background: #f9fafb;
}

.creer-candidature-result-nom {
  font-size: 13px;
  color: #374151;
  font-weight: 500;
}

.creer-candidature-result-warn {
  font-size: 11px;
  color: #dc2626;
  margin-left: auto;
}

.creer-candidature-search-empty {
  padding: 10px 14px;
  font-size: 13px;
  color: #9ca3af;
}

/* Liste membres ajoutés */
.creer-candidature-membres-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.creer-candidature-membres-count {
  font-size: 12px;
  color: #6b7280;
  margin: 0 0 4px;
}

.creer-candidature-membre-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.creer-candidature-membre-nom {
  font-size: 13px;
  color: #374151;
  font-weight: 500;
  flex: 1 1;
}

.creer-candidature-membre-remove {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  color: #9ca3af;
  padding: 0 4px;
  border-radius: 4px;
  transition:
    color 0.15s,
    background 0.15s;
  flex-shrink: 0;
}

.creer-candidature-membre-remove:hover {
  color: #dc2626;
  background: #fef2f2;
}

.creer-candidature-error-link {
  color: #595959;
  /* text-decoration: none; */
  font-weight: 500;
  /* transition: text-decoration 0.15s; */
}

.creer-candidature-modal-close {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: #9ca3af;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition:
    color 0.15s,
    background 0.15s;
}

.creer-candidature-modal-close:hover {
  color: #374151;
  background: #f3f4f6;
}

/* Body */
.creer-candidature-modal-body {
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 22px;
}

/* Sections */
.creer-candidature-section-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #595959;
  margin-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

/* Select lot technique */
.creer-candidature-select {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  color: #374151;
  background: #fff;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
  cursor: pointer;
  transition: border-color 0.15s;
}

.creer-candidature-select:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
}

.creer-candidature-select:disabled {
  background-color: #f9fafb;
  cursor: not-allowed;
  color: #9ca3af;
}

/* Liste des lots / régions / départements */
.creer-candidature-lots-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px;
}

/* Groupe région */
.creer-candidature-region-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.creer-candidature-region-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  background: #f9fafb;
  border-radius: 6px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.creer-candidature-region-header:hover {
  background: #f3f4f6;
}

.creer-candidature-region-header input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #f97316;
  cursor: pointer;
  flex-shrink: 0;
}

.creer-candidature-region-name {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.creer-candidature-region-count {
  font-size: 12px;
  color: #9ca3af;
  margin-left: auto;
}

/* Départements sous une région */
.creer-candidature-region-depts {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-left: 24px;
}

/* Ligne département / lot checkbox */
.creer-candidature-lot-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 10px;
  border-radius: 6px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background 0.12s;
}

.creer-candidature-lot-item:hover {
  background: #fff7ed;
}

.creer-candidature-lot-item input[type="checkbox"] {
  width: 15px;
  height: 15px;
  accent-color: #f97316;
  cursor: pointer;
  flex-shrink: 0;
}

.creer-candidature-lot-item-label {
  font-size: 13px;
  color: #374151;
  line-height: 1.4;
}

.creer-candidature-lot-item-code {
  font-size: 11px;
  color: #9ca3af;
  margin-left: auto;
  white-space: nowrap;
}

/* Loading / empty states */
.creer-candidature-loading {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #6b7280;
  padding: 12px 0;
}

.creer-candidature-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid #e5e7eb;
  border-top-color: #f97316;
  border-radius: 50%;
  animation: creerBtnSpin 0.7s linear infinite;
  flex-shrink: 0;
}

@keyframes creerSpin {
  from {
    transform: translateY(-50%) rotate(0deg);
  }
  to {
    transform: translateY(-50%) rotate(360deg);
  }
}

@keyframes creerBtnSpin {
  to {
    transform: rotate(360deg);
  }
}

.creer-candidature-empty {
  font-size: 13px;
  color: #9ca3af;
  text-align: center;
  padding: 16px 0;
}

/* Sélection counter */
.creer-candidature-selection-count {
  font-size: 12px;
  color: #6b7280;
  margin-top: -10px;
}

.creer-candidature-selection-count strong {
  color: #f97316;
}

/* Erreur API */
.creer-candidature-error {
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 13px;
  color: #dc2626;
}

/* Bannière profil incomplet */
.creer-candidature-profil-incomplet {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #fffbeb;
  border: 1px solid #fcd34d;
  border-radius: 8px;
  padding: 14px 16px;
  font-size: 13px;
  color: #92400e;
}

.creer-candidature-profil-incomplet-icon {
  flex-shrink: 0;
  margin-top: 1px;
  color: #d97706;
}

.creer-candidature-profil-incomplet-text {
  flex: 1 1;
}

.creer-candidature-profil-incomplet-text strong {
  display: block;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 2px;
}

.creer-candidature-profil-incomplet-text p {
  margin: 0;
  font-size: 13px;
}

.creer-candidature-profil-incomplet-link {
  flex-shrink: 0;
  align-self: center;
  padding: 7px 14px;
  background: #f97316;
  color: #fff;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
}

.creer-candidature-profil-incomplet-link:hover {
  background: #ea6c0a;
}

/* Bandeau Phase 2 */
.creer-candidature-phase2-banner {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 13px;
  color: #1e40af;
  font-weight: 500;
  margin-bottom: 8px;
}

/* Footer */
.creer-candidature-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 28px;
  border-top: 1px solid #e5e7eb;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Publications/components/CreerCandidatureModal/CreerCandidatureModal.css"],"names":[],"mappings":"AAAA,8DAA8D;;AAE9D,YAAY;AACZ;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd;;;;;cAKY;AACd;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd;;;;;cAKY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA,uEAAuE;;AAEvE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf;;oBAEkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,oEAAoE;;AAEpE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd;;;;;cAKY;EACZ,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf;;;;;cAKY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB;;oBAEkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB;;oBAEkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,aAAa;AACb;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,yDAAyN;EACzN,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;EACrB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE;IACE,wCAAwC;EAC1C;EACA;IACE,0CAA0C;EAC5C;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B","sourcesContent":["/* EPIC-10 — CreerCandidatureModal — Design System Centralis */\n\n/* Overlay */\n.creer-candidature-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 99999;\n  backdrop-filter: blur(4px);\n}\n\n/* Modal container */\n.creer-candidature-modal {\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  max-width: 680px;\n  width: 95%;\n  max-height: 90vh;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  animation: creerCandidatureSlideIn 0.25s ease-out;\n}\n\n@keyframes creerCandidatureSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-24px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Header */\n.creer-candidature-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 22px 28px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.creer-candidature-header-left {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.creer-candidature-modal-header h2 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #595959;\n  font-family:\n    \"Inter\",\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    sans-serif;\n}\n\n/* Stepper */\n.creer-candidature-steps {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.creer-candidature-step {\n  font-size: 12px;\n  font-weight: 500;\n  color: #9ca3af;\n  font-family:\n    \"Inter\",\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    sans-serif;\n  transition: color 0.15s;\n}\n\n.creer-candidature-step.active {\n  color: #f97316;\n  font-weight: 600;\n}\n\n.creer-candidature-step.done {\n  color: #6b7280;\n}\n\n.creer-candidature-step-sep {\n  font-size: 14px;\n  color: #d1d5db;\n  line-height: 1;\n}\n\n/* ── Étape 2 ─────────────────────────────────────────────────────── */\n\n.creer-candidature-step2 {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* Choix solo / groupement */\n.creer-candidature-type-choices {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.creer-candidature-type-option {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 14px 16px;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 10px;\n  cursor: pointer;\n  transition:\n    border-color 0.15s,\n    background 0.15s;\n  user-select: none;\n}\n\n.creer-candidature-type-option:hover {\n  border-color: #f97316;\n  background: #fff7ed;\n}\n\n.creer-candidature-type-option.selected {\n  border-color: #f97316;\n  background: #fff7ed;\n}\n\n.creer-candidature-type-option input[type=\"radio\"] {\n  margin-top: 2px;\n  width: 16px;\n  height: 16px;\n  accent-color: #f97316;\n  flex-shrink: 0;\n  cursor: pointer;\n}\n\n.creer-candidature-type-label {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 2px;\n}\n\n.creer-candidature-type-desc {\n  display: block;\n  font-size: 12px;\n  color: #6b7280;\n  line-height: 1.5;\n}\n\n/* ── Membres / invitation ─────────────────────────────────────── */\n\n.creer-candidature-membres {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.creer-candidature-search-wrapper {\n  position: relative;\n}\n\n.creer-candidature-search-input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 10px 14px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #374151;\n  font-family:\n    \"Inter\",\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    sans-serif;\n  transition: border-color 0.15s;\n}\n\n.creer-candidature-search-input:focus {\n  outline: none;\n  border-color: #f97316;\n  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);\n}\n\n.creer-candidature-search-spinner {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 16px;\n  height: 16px;\n  border: 2px solid #e5e7eb;\n  border-top-color: #f97316;\n  border-radius: 50%;\n  animation: creerSpin 0.7s linear infinite;\n  pointer-events: none;\n}\n\n.creer-candidature-search-results {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);\n  z-index: 100;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.creer-candidature-search-result-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 10px 14px;\n  background: none;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n  font-family:\n    \"Inter\",\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    sans-serif;\n  transition: background 0.12s;\n}\n\n.creer-candidature-search-result-item:hover {\n  background: #fff7ed;\n}\n\n.creer-candidature-search-result-item:disabled,\n.creer-candidature-search-result-item.disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n  background: #f9fafb;\n}\n\n.creer-candidature-search-result-item:disabled:hover,\n.creer-candidature-search-result-item.disabled:hover {\n  background: #f9fafb;\n}\n\n.creer-candidature-result-nom {\n  font-size: 13px;\n  color: #374151;\n  font-weight: 500;\n}\n\n.creer-candidature-result-warn {\n  font-size: 11px;\n  color: #dc2626;\n  margin-left: auto;\n}\n\n.creer-candidature-search-empty {\n  padding: 10px 14px;\n  font-size: 13px;\n  color: #9ca3af;\n}\n\n/* Liste membres ajoutés */\n.creer-candidature-membres-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.creer-candidature-membres-count {\n  font-size: 12px;\n  color: #6b7280;\n  margin: 0 0 4px;\n}\n\n.creer-candidature-membre-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n}\n\n.creer-candidature-membre-nom {\n  font-size: 13px;\n  color: #374151;\n  font-weight: 500;\n  flex: 1;\n}\n\n.creer-candidature-membre-remove {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 18px;\n  line-height: 1;\n  color: #9ca3af;\n  padding: 0 4px;\n  border-radius: 4px;\n  transition:\n    color 0.15s,\n    background 0.15s;\n  flex-shrink: 0;\n}\n\n.creer-candidature-membre-remove:hover {\n  color: #dc2626;\n  background: #fef2f2;\n}\n\n.creer-candidature-error-link {\n  color: #595959;\n  /* text-decoration: none; */\n  font-weight: 500;\n  /* transition: text-decoration 0.15s; */\n}\n\n.creer-candidature-modal-close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  color: #9ca3af;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  transition:\n    color 0.15s,\n    background 0.15s;\n}\n\n.creer-candidature-modal-close:hover {\n  color: #374151;\n  background: #f3f4f6;\n}\n\n/* Body */\n.creer-candidature-modal-body {\n  padding: 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n}\n\n/* Sections */\n.creer-candidature-section-label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #595959;\n  margin-bottom: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n/* Select lot technique */\n.creer-candidature-select {\n  width: 100%;\n  padding: 10px 14px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #374151;\n  background: #fff;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  background-size: 16px;\n  cursor: pointer;\n  transition: border-color 0.15s;\n}\n\n.creer-candidature-select:focus {\n  outline: none;\n  border-color: #f97316;\n  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);\n}\n\n.creer-candidature-select:disabled {\n  background-color: #f9fafb;\n  cursor: not-allowed;\n  color: #9ca3af;\n}\n\n/* Liste des lots / régions / départements */\n.creer-candidature-lots-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 300px;\n  overflow-y: auto;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 10px;\n}\n\n/* Groupe région */\n.creer-candidature-region-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.creer-candidature-region-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  background: #f9fafb;\n  border-radius: 6px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.creer-candidature-region-header:hover {\n  background: #f3f4f6;\n}\n\n.creer-candidature-region-header input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: #f97316;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.creer-candidature-region-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.creer-candidature-region-count {\n  font-size: 12px;\n  color: #9ca3af;\n  margin-left: auto;\n}\n\n/* Départements sous une région */\n.creer-candidature-region-depts {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding-left: 24px;\n}\n\n/* Ligne département / lot checkbox */\n.creer-candidature-lot-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 7px 10px;\n  border-radius: 6px;\n  cursor: pointer;\n  user-select: none;\n  transition: background 0.12s;\n}\n\n.creer-candidature-lot-item:hover {\n  background: #fff7ed;\n}\n\n.creer-candidature-lot-item input[type=\"checkbox\"] {\n  width: 15px;\n  height: 15px;\n  accent-color: #f97316;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.creer-candidature-lot-item-label {\n  font-size: 13px;\n  color: #374151;\n  line-height: 1.4;\n}\n\n.creer-candidature-lot-item-code {\n  font-size: 11px;\n  color: #9ca3af;\n  margin-left: auto;\n  white-space: nowrap;\n}\n\n/* Loading / empty states */\n.creer-candidature-loading {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  color: #6b7280;\n  padding: 12px 0;\n}\n\n.creer-candidature-spinner {\n  width: 18px;\n  height: 18px;\n  border: 2px solid #e5e7eb;\n  border-top-color: #f97316;\n  border-radius: 50%;\n  animation: creerBtnSpin 0.7s linear infinite;\n  flex-shrink: 0;\n}\n\n@keyframes creerSpin {\n  from {\n    transform: translateY(-50%) rotate(0deg);\n  }\n  to {\n    transform: translateY(-50%) rotate(360deg);\n  }\n}\n\n@keyframes creerBtnSpin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.creer-candidature-empty {\n  font-size: 13px;\n  color: #9ca3af;\n  text-align: center;\n  padding: 16px 0;\n}\n\n/* Sélection counter */\n.creer-candidature-selection-count {\n  font-size: 12px;\n  color: #6b7280;\n  margin-top: -10px;\n}\n\n.creer-candidature-selection-count strong {\n  color: #f97316;\n}\n\n/* Erreur API */\n.creer-candidature-error {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  padding: 12px 16px;\n  font-size: 13px;\n  color: #dc2626;\n}\n\n/* Bannière profil incomplet */\n.creer-candidature-profil-incomplet {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  background: #fffbeb;\n  border: 1px solid #fcd34d;\n  border-radius: 8px;\n  padding: 14px 16px;\n  font-size: 13px;\n  color: #92400e;\n}\n\n.creer-candidature-profil-incomplet-icon {\n  flex-shrink: 0;\n  margin-top: 1px;\n  color: #d97706;\n}\n\n.creer-candidature-profil-incomplet-text {\n  flex: 1;\n}\n\n.creer-candidature-profil-incomplet-text strong {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 2px;\n}\n\n.creer-candidature-profil-incomplet-text p {\n  margin: 0;\n  font-size: 13px;\n}\n\n.creer-candidature-profil-incomplet-link {\n  flex-shrink: 0;\n  align-self: center;\n  padding: 7px 14px;\n  background: #f97316;\n  color: #fff;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.creer-candidature-profil-incomplet-link:hover {\n  background: #ea6c0a;\n}\n\n/* Bandeau Phase 2 */\n.creer-candidature-phase2-banner {\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 8px;\n  padding: 10px 16px;\n  font-size: 13px;\n  color: #1e40af;\n  font-weight: 500;\n  margin-bottom: 8px;\n}\n\n/* Footer */\n.creer-candidature-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 20px 28px;\n  border-top: 1px solid #e5e7eb;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
